import type { Tag, TagScope } from "@/types/tag";

import { createId, createPastTimestamp } from "./base";

interface TagConfig {
  name: string;
  color: string;
  scopes: TagScope[];
}

const CLINIC_TAGS: TagConfig[] = [
  { name: "VIP Patient", color: "#FFD700", scopes: ["inbox"] },
  { name: "Follow-up Needed", color: "#FF6B6B", scopes: ["inbox", "ticket"] },
  { name: "Insurance Verified", color: "#4ECDC4", scopes: ["inbox"] },
  { name: "Payment Pending", color: "#FFA07A", scopes: ["inbox", "ticket"] },
  { name: "New Patient", color: "#87CEEB", scopes: ["inbox"] },
  { name: "Returning Patient", color: "#98D8C8", scopes: ["inbox"] },
  { name: "Referred", color: "#DDA0DD", scopes: ["inbox"] },
  { name: "Urgent", color: "#FF4444", scopes: ["ticket"] },
  { name: "High Priority", color: "#FF4444", scopes: ["ticket"] },
  { name: "New Arrival", color: "#FFB6C1", scopes: ["product"] },
  { name: "Best Seller", color: "#9370DB", scopes: ["product"] },
];

/**
 * Generate tags for a clinic
 */
export function generateTags(
  _organizationId: string,
  _workspaceId: string,
  count: number = 11,
): Tag[] {
  const timestamp = createPastTimestamp(60);

  return CLINIC_TAGS.slice(0, count).map((config) => ({
    id: createId(),
    name: config.name,
    color: config.color,
    scopes: config.scopes,
    createdAt: timestamp,
    updatedAt: timestamp,
    attachedAt: timestamp,
  }));
}
